/****************************************************************************
 **
 ** Copyright (C) 2021 The Qt Company Ltd.
 ** Contact: https://www.qt.io/licensing/
 **
 ** This file is part of Qt Bridge Plugin.
 **
 ** Commercial License Usage
 ** Licensees holding valid commercial Qt licenses may use this file in
 ** accordance with the commercial license agreement provided with the
 ** Software or, alternatively, in accordance with the terms contained in
 ** a written agreement between you and The Qt Company. For licensing terms
 ** and conditions see https://www.qt.io/terms-conditions. For further
 ** information use the contact form at https://www.qt.io/contact-us.
 **
 ****************************************************************************/
import { BUtils } from "./qtbridgeutils.js";
import Settings from "sketch/settings";

export class Metadata {
    constructor(instance, objectDict) {
        this._instance = instance;
        this._dict = objectDict;
    }

    setMetadata(propertyName, value) {
        return writeSettings.call(this, propertyName, value);
    }

    metadata(propertyname) {
        return readSettings.call(this, propertyname);
    }

    allMetadata() {
        let data = {};
        for (const propName in this._dict) {
            const value = this.metadata(propName);
            if (value !== undefined) {
                data[propName] = value;
            }
        }
        return data;
    }

    resetMetadata(name) {
        return writeSettings.call(this, name, undefined);
    }
}

function readSettings(key) {
    if (!this._instance) {
        BUtils.logError(`Can not read setting [${key}]. Invalid instance.`);
        return undefined;
    }

    if (!(key in this._dict)) {
        BUtils.logError(`readSettings error. Invalid key:${key} in ${this._instance.name}`);
        return undefined;
    }

    let value;
    try {
        if (this._instance.type === "Document") {
            value = Settings.documentSettingForKey(this._instance, key);
        } else {
            value = Settings.layerSettingForKey(this._instance, key);
        }

        if (value === undefined) {
            // Check for default values.
            var defaultFunction = this._dict[key];
            if (defaultFunction !== undefined) {
                value = defaultFunction.call(null, this._instance);
            }
        }
    } catch (e) {
        BUtils.logError(`ReadSettings Exception: ${e.toString()}`);
    }
    return value;
}

function writeSettings(key, value) {
    if (!this._instance) {
        return false;
    }

    if (!(key in this._dict)) {
        BUtils.logError(`writeSettings error. Invalid key:${key} in ${this._instance.name}`);
        return false;
    }

    BUtils.logError(`writeSettings. key:${key} value ${value}`);

    let success = true;
    try {
        if (this._instance.type === "Document") {
            Settings.setDocumentSettingForKey(this._instance, key, value);
        } else {
            Settings.setLayerSettingForKey(this._instance, key, value);
        }
    } catch (e) {
        BUtils.logError(e.toString());
        success = false;
    }
    return success;
}
